/**
 * Implementation of metro select component
 *
 * @author - Harsh Tomar
 */

// Dependencies
import React, { ReactNode } from "react";
import { BsFillCheckCircleFill } from "react-icons/bs"; 

type Props = {
  options: string[] | ReactNode[];
  selected: number | number[];
  onSelect: (selected: number | number[]) => void;
  multi?: boolean
};

export default function MetroSelect(props: Props) {
  function _handleSelect(index: number) {
    if(props.multi) {
      if(Array.from(props.selected as number[]).includes(index)) {
        return props.onSelect(Array.from(props.selected as number[]).filter(selected => selected !== index))
      } else
        return props.onSelect([...Array.from(props.selected as number[]), index])
    }
    return props.onSelect(index);
  }

  function isSelected(index: number) {
    if(props.multi)
      return Array.from(props.selected as number[]).includes(index)
    return props.selected === index
  }

  return (
    <div className="flex flex-wrap">
      {props.options.map((option, index) => (
        <div
          className={`rounded-lg border border-gray-400 hover:ring-offset-2 hover:ring-2 ring-accent cursor-pointer mr-4 flex-1 relative transition-all ${
            isSelected(index) ? "ring-offset-2 ring-2" : ""
          }`}
          onClick={() => _handleSelect(index)}
        >
          {option}
          {isSelected(index) && <BsFillCheckCircleFill className="text-accent absolute top-2 right-2" size={22}/> }
        </div>
      ))}
    </div>
  );
}
